module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"ACC MANAGEMENT SYSTEM","pageName":"Home"}}')
  delete Component.options._Ctor
}
